import React from "react";
import sortSelectOptions from "../form/sortSelectOptions";

const $ticketReasonSelect = document.querySelector("#ticket_reason_field[data-reasons]");
export const availableReasons = JSON.parse($ticketReasonSelect.dataset.reasons);

const dataSelectedReason = $ticketReasonSelect.dataset.selectedReason;
const dataPlaceholder = $ticketReasonSelect.dataset.placeholder;
const dataRequestTypeCode = document.querySelector("#ticket_request_type_field").dataset
  .selectedRequestTypeCode;

class ReasonSelect extends React.Component {
  constructor(props) {
    super(props);

    const $requestTypeSelect = this.requestTypeSelect();
    const selectRequestTypeCode =
      $requestTypeSelect.selectedOptions[$requestTypeSelect.selectedIndex]?.dataset?.code;
    const requestTypeCode = selectRequestTypeCode || dataRequestTypeCode;

    this.state = {
      reasons: this.reasons(requestTypeCode),
    };

    this.addRequestTypeSelectEventListener();
  }

  addRequestTypeSelectEventListener() {
    this.requestTypeSelect().addEventListener("change", this.handleRequestTypeChange.bind(this));
  }

  requestTypeSelect() {
    return document.querySelector('select[name="ticket[request_type_id]"]');
  }

  handleRequestTypeChange({ target: { options, selectedIndex } }) {
    const selectRequestTypeCode = options[selectedIndex].dataset.code;
    this.setState({ reasons: this.reasons(selectRequestTypeCode) });
  }

  reasons(selectRequestTypeCode) {
    return sortSelectOptions(availableReasons[selectRequestTypeCode] || []);
  }

  render() {
    const { reasons } = this.state;

    return (
      <div>
        <select name="ticket[reason]" defaultValue={dataSelectedReason}>
          <option value="">{dataPlaceholder}</option>
          {reasons.map(({ code, name }) => {
            return (
              <option key={name} value={code}>
                {name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

export default ReasonSelect;
